import { useState } from 'react';
import { eventsApi } from '../../lib/api';

const cardStyle = { background: 'rgba(255,255,255,0.97)', border: '1px solid #E2E8F0', borderRadius: 20, boxShadow: '0 8px 32px rgba(0,0,0,0.08)', padding: 24 };
const inputStyle = { width: '100%', padding: '10px 14px', borderRadius: 12, border: '2px solid #E2E8F0', fontSize: 14, fontFamily: 'Poppins, sans-serif', background: 'rgba(255,255,255,0.7)', color: '#0F172A', outline: 'none', boxSizing: 'border-box' };
const labelStyle = { display: 'block', fontSize: 12, fontWeight: 600, color: '#0F172A', marginBottom: 4, fontFamily: 'Poppins, sans-serif' };
const btnPrimary = { padding: '10px 20px', borderRadius: 14, background: '#c9a84c', color: 'white', fontSize: 13, fontWeight: 600, fontFamily: 'Poppins, sans-serif', border: 'none', cursor: 'pointer' };

const CATEGORIES = [
  'arts_crafts', 'action_figures', 'fashion_dolls', 'preschool', 'electronics',
  'family_games', 'party_games', 'outdoor', 'plush', 'collectibles', 'show_ip', 'books',
];

export default function CompanyManager({ eventId, eventDetail, onRefresh }) {
  const companies = eventDetail?.companies || [];
  const [showAdd, setShowAdd] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    company_name: '', contact_name: '', contact_email: '', company_type: 'manufacturer',
    nda_link: '', categories_seeking: [], additional_guidelines: '',
    calendly_slot_start: '', calendly_slot_end: '', zoom_link: '', phone: '',
  });

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!form.company_name || !form.contact_email) return;
    setSaving(true);
    try {
      await eventsApi.addCompanyFull(eventId, form);
      setShowAdd(false);
      setForm({ company_name: '', contact_name: '', contact_email: '', company_type: 'manufacturer', nda_link: '', categories_seeking: [], additional_guidelines: '', calendly_slot_start: '', calendly_slot_end: '', zoom_link: '', phone: '' });
      onRefresh();
    } catch (err) { console.error(err); }
    setSaving(false);
  };

  const handleRemove = async (companyId) => {
    if (!window.confirm('Remove this company from the event?')) return;
    try { await eventsApi.removeCompany(eventId, companyId); onRefresh(); }
    catch (err) { console.error(err); }
  };

  const toggleCategory = (cat) => {
    setForm(prev => ({
      ...prev,
      categories_seeking: prev.categories_seeking.includes(cat)
        ? prev.categories_seeking.filter(c => c !== cat)
        : [...prev.categories_seeking, cat],
    }));
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2 style={{ fontFamily: '"EB Garamond", serif', fontSize: 22, color: '#0F172A', margin: 0 }}>
          Companies ({companies.length})
        </h2>
        <button onClick={() => setShowAdd(!showAdd)} style={btnPrimary}>
          {showAdd ? 'Cancel' : '+ Add Company'}
        </button>
      </div>

      {/* Add company form */}
      {showAdd && (
        <div style={{ ...cardStyle, marginBottom: 24 }}>
          <form onSubmit={handleAdd}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
              <div><label style={labelStyle}>Company Name *</label><input value={form.company_name} onChange={e => setForm({ ...form, company_name: e.target.value })} style={inputStyle} /></div>
              <div><label style={labelStyle}>Contact Name</label><input value={form.contact_name} onChange={e => setForm({ ...form, contact_name: e.target.value })} style={inputStyle} /></div>
              <div><label style={labelStyle}>Contact Email *</label><input type="email" value={form.contact_email} onChange={e => setForm({ ...form, contact_email: e.target.value })} style={inputStyle} /></div>
              <div><label style={labelStyle}>Phone</label><input value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} style={inputStyle} /></div>
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={labelStyle}>Company Type</label>
              <select value={form.company_type} onChange={e => setForm({ ...form, company_type: e.target.value })} style={inputStyle}>
                <option value="retailer">Retailer (looking to buy wholesale)</option>
                <option value="manufacturer">Manufacturer (looking to license)</option>
                <option value="agent">Agent (looking for talent)</option>
                <option value="other">Other</option>
              </select>
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={labelStyle}>Categories Seeking</label>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                {CATEGORIES.map(cat => (
                  <button key={cat} type="button" onClick={() => toggleCategory(cat)} style={{
                    padding: '6px 12px', borderRadius: 10, fontSize: 12, fontWeight: 500, fontFamily: 'Poppins, sans-serif',
                    border: form.categories_seeking.includes(cat) ? '2px solid #c9a84c' : '2px solid #E2E8F0',
                    background: form.categories_seeking.includes(cat) ? 'rgba(201,168,76,0.05)' : 'transparent',
                    color: form.categories_seeking.includes(cat) ? '#a88a2e' : '#64748B', cursor: 'pointer', textTransform: 'capitalize',
                  }}>
                    {cat.replace(/_/g, ' ')}
                  </button>
                ))}
              </div>
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={labelStyle}>NDA Link (URL to NDA document)</label>
              <input value={form.nda_link} onChange={e => setForm({ ...form, nda_link: e.target.value })} placeholder="https://..." style={inputStyle} />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={labelStyle}>Additional Guidelines</label>
              <textarea value={form.additional_guidelines} onChange={e => setForm({ ...form, additional_guidelines: e.target.value })} rows={2} style={{ ...inputStyle, resize: 'none' }} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
              <div><label style={labelStyle}>Calendly Slot Start</label><input type="datetime-local" value={form.calendly_slot_start} onChange={e => setForm({ ...form, calendly_slot_start: e.target.value })} style={inputStyle} /></div>
              <div><label style={labelStyle}>Calendly Slot End</label><input type="datetime-local" value={form.calendly_slot_end} onChange={e => setForm({ ...form, calendly_slot_end: e.target.value })} style={inputStyle} /></div>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={labelStyle}>Zoom Link</label>
              <input value={form.zoom_link} onChange={e => setForm({ ...form, zoom_link: e.target.value })} placeholder="https://zoom.us/j/..." style={inputStyle} />
            </div>
            <button type="submit" disabled={saving} style={{ ...btnPrimary, width: '100%', opacity: saving ? 0.5 : 1 }}>
              {saving ? 'Adding...' : 'Add Company to Event'}
            </button>
          </form>
        </div>
      )}

      {/* Company list */}
      {companies.length === 0 ? (
        <div style={{ ...cardStyle, textAlign: 'center', padding: 48 }}>
          <p style={{ fontSize: 14, color: '#94A3B8', fontFamily: 'Poppins, sans-serif' }}>No companies added yet</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {companies.map(ec => (
            <div key={ec.id} style={cardStyle}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div>
                  <h3 style={{ fontFamily: 'Poppins, sans-serif', fontSize: 15, fontWeight: 600, color: '#0F172A', margin: '0 0 4px' }}>
                    {ec.companies?.name || ec.contact_name}
                  </h3>
                  <div style={{ fontSize: 12, color: '#94A3B8', fontFamily: 'Poppins, sans-serif' }}>
                    {ec.contact_email} {ec.company_type && `· ${ec.company_type}`}
                  </div>
                  {ec.categories_seeking?.length > 0 && (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginTop: 8 }}>
                      {ec.categories_seeking.map(cat => (
                        <span key={cat} style={{ padding: '2px 8px', borderRadius: 999, fontSize: 11, fontWeight: 500, background: '#EEF2FF', color: '#4F46E5', fontFamily: 'Poppins, sans-serif', textTransform: 'capitalize' }}>
                          {cat.replace(/_/g, ' ')}
                        </span>
                      ))}
                    </div>
                  )}
                  {ec.calendly_slot_start && (
                    <div style={{ fontSize: 12, color: '#64748B', marginTop: 8, fontFamily: 'Poppins, sans-serif' }}>
                      Slot: {new Date(ec.calendly_slot_start).toLocaleString([], { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}
                      {ec.calendly_slot_end && ` - ${new Date(ec.calendly_slot_end).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`}
                    </div>
                  )}
                  {(ec.nda_link || ec.nda_file_url) && (
                    <div style={{ fontSize: 12, color: '#10B981', marginTop: 4, fontFamily: 'Poppins, sans-serif' }}>
                      NDA: {ec.nda_link ? 'Link provided' : 'File uploaded'}
                    </div>
                  )}
                </div>
                <button onClick={() => handleRemove(ec.company_id)} style={{ background: 'none', border: 'none', color: '#CBD5E1', cursor: 'pointer', fontSize: 18 }}>×</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
